module.exports = __webpack_public_path__ + "static/media/oil.01388994.svg";